(function () {
  function init(root) {
    var img = root.querySelector('#efPreviewImg');
    var label = root.querySelector('#efColorLabel');
    var cta = root.querySelector('#efPreviewCta');
    var swatches = Array.prototype.slice.call(root.querySelectorAll('.ef-swatch'));
    if (!img || !swatches.length) return;

    function activate(btn) {
      swatches.forEach(function (s) {
        var on = s === btn;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var src = btn.getAttribute('data-img');
      if (src) img.src = src;
      img.alt = (btn.getAttribute('data-label') || '') + ' product photo';
      if (label) label.textContent = btn.getAttribute('data-label') || '';
      if (cta && btn.getAttribute('data-url')) cta.setAttribute('href', btn.getAttribute('data-url'));
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () { activate(btn); });
    });
    activate(swatches[0]);
  }

  document.querySelectorAll('[data-ef-landing]').forEach(init);
})();
